export enum PageLifecycleType {
  Init = 'init',
  Destroy = 'destroy'
}
